import { Menu } from '@headlessui/react'
import { ErrorMessage, useFormikContext } from 'formik'
import AddFilledIcon from 'icons/add-filled'
import ArrowDropdownIcon from 'icons/arrow-dropdown'
import RemoveIcon from 'icons/remove'


function ListInputField({ label,
  required,
  btnLabel,
  name,
  type,
  className,
  showAddButton = true,
}) {
  const formik = useFormikContext()

  const addField = () => {
    formik.setFieldValue(name, [...formik.values[name], ''])
  }

  const removeField = (idx) => {
    formik.values[name].splice(idx, 1)
    formik.setValues({ ...formik.values })
  }

  return (
    <div className={className}>
      <label class='tw-mb-2 tw-text-regular tw-text-navyBlue tw-flex tw-justify-between'>
        <div>
          {label}
          {required && <span class='tw-ml-2 tw-text-red-600'>*</span>}
        </div>
      </label>
      {formik.values[name].map((item, idx) => (
        <>
          <div class='tw-flex tw-items-center tw-border tw-border-slate-300 tw-my-2 tw-rounded-md'>
          <div class='tw-cursor-pointer tw-flex tw-flex-none tw-items-center tw-w-10 tw-relative tw-text-center tw-text-slate-400 tw-text-sm'>
          <div
                onClick={() => removeField(idx)}
                class='tw-ml-4 tw-mr-2 tw-my-[6px]'
              >
                <RemoveIcon />
              </div>
            </div>

            <input
              autocapitalize='off'
              class='tw-text-regular tw-leading-regular tw-appearance-none tw-block tw-border-none tw-rounded-md tw-placeholder-gray-300 tw-flex-1 tw-px-[10px] tw-py-[5px] tw-w-full tw-z-10$'
              type={type || 'text'}
              {...formik.getFieldProps(`${name}[${idx}].value`)}
            />
            <div class='tw-text-xs tw-font-light tw-text-red-600 tw-mt-2'></div>
          </div>
          <ErrorMessage
            component='div'
            className='error'
            name={`${name}[${idx}].value`}
          />
        </>
      ))}
        {showAddButton && (
          <button
            class='tw-border tw-border-slate-300 tw-flex tw-hover:bg-slate-50 tw-items-center tw-justify-center tw-mt-3 tw-p-2 tw-rounded-md tw-text-slate-400 tw-text-regular tw-transition-colors tw-w-full'
            type='button'
            onClick={addField}
          >
            <AddFilledIcon />
            <span class='tw-ml-1.5'>Add {btnLabel}</span>
          </button>
        )}
    </div>
  )
}

export default ListInputField
